import { Component } from '@angular/core';

@Component({
  selector: 'ui-stepper',
  templateUrl: './stepper.html',
})
export class Stepper {}
